import { render, staticRenderFns } from "./bannerCorona.vue?vue&type=template&id=de5bf8d2&scoped=true"
import script from "./bannerCorona.ts?vue&type=script&lang=ts&external"
export * from "./bannerCorona.ts?vue&type=script&lang=ts&external"
import style0 from "./bannerCorona.vue?vue&type=style&index=0&id=de5bf8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5bf8d2",
  null
  
)

export default component.exports